import { SFTPUsersApi } from './permission-api-client/api/sftpusers-api';
import type { AssignUsersPayloadDto } from './permission-api-client/models';
import { initializePermissionApi } from './utils';

export const sftpUsersApi = initializePermissionApi(SFTPUsersApi);

export async function assignUsersToAssignment(
  assignmentId: string,
  payload: Pick<AssignUsersPayloadDto, 'addUsers' | 'removeUsers'>,
) {
  const requestPayload = {
    assignmentId,
    assignUsersPayloadDto: {
      addUsers: payload.addUsers ?? [],
      removeUsers: payload.removeUsers ?? [],
    },
  };

  return sftpUsersApi.assignUsersToAssignment(requestPayload);
}
